import Vue from 'vue'
import App from './App.vue'
import store from './store';
import Confirm from './plugins/Confirm.js';
import VueI18n from 'vue-i18n';
import { languages, defaultLocale } from "./locales";
import globalMixin from "@/components/helpers/globalMixin";

import "./scss/conflicts.scss";
import vatToggle from "@/vatToggle";

Vue.use(VueI18n);

const messages = Object.assign(languages);

export const dataSet = document.getElementById('decision-aid').dataset;
let language = new URLSearchParams(window.location.search).get('language') || dataSet.lang || defaultLocale;

let i18n = new VueI18n({
  locale: language,
  fallbackLocale: defaultLocale,
  messages
})

export const locale = i18n.locale;

Vue.config.productionTip = false
Vue.prototype.$confirm = Confirm;

Vue.mixin(globalMixin);

new Vue({
  store,
  i18n,
  render: h => h(App),
  mounted() {
    vatToggle(this.$store)
  }
}).$mount('#decision-aid')
